import { Box, Grid, Typography } from '@mui/material';
import ComposedDrawerMenuAppBar from 'components/ComposedDrawerMenuAppBar';

import { useTranslation } from 'react-i18next';
import DashboardAnalyticsView from './DashboardAnalyticsView';
import DashboardUpcomingRidesTable from './DashboardUpcomingRidesTable';

function DashboardView() {
  const tInstance = useTranslation();
  const { t } = tInstance;

  return (
    <>
      <ComposedDrawerMenuAppBar title={t('DashboardView.title').toString()} />
      <Box sx={{ p: { xs: 1, md: 2 } }}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography
              sx={{
                color: '#1F2232',
                fontSize: '24px',
                lineHeight: '32px',
                fontWeight: 500,
                marginBottom: '1.5rem',
              }}
            >
              {t('DashboardView.analytics.title')}
            </Typography>
            <DashboardAnalyticsView />
          </Grid>
          <Grid item xs={12}>
            <Typography
              sx={{
                color: '#1F2232',
                fontSize: '18px',
                lineHeight: '28px',
                fontWeight: 500,
                marginBottom: '1.5rem',
              }}
            >
              {t('DashboardView.analytics.upcomingRides')}
            </Typography>
            <DashboardUpcomingRidesTable />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default DashboardView;
